"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4433%3A479))
 * @trackcomponent
 * @lastsynced 2025-07-08T18:36:53.283Z
 * @optimized using svgo:^3.0.2
 */
export const ThumbsUp = createSVGIcon(
  <path
    d="M2.218 10.052h3.863v10.284H2.218a.815.815 0 0 1-.815-.815v-8.654a.815.815 0 0 1 .815-.816ZM6.081 10.051l4.14-6.617a1.78 1.78 0 0 1 1.532-.848 1.81 1.81 0 0 1 1.874 1.793v4.743h7.156a1.874 1.874 0 0 1 1.792 2.151l-1.303 8.41a1.86 1.86 0 0 1-1.842 1.63H8.738a3.26 3.26 0 0 1-1.467-.342l-1.174-.587M6.081 10.051v10.285"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ThumbsUp",
  {
    color: Core.icon.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
